import { FullscreenSubcontentWithBackgroundProps } from '../subcontent_modules/background'
export const setElementSrc = (el: HTMLImageElement, src: string) => {
  return (el.src = src)
}

export const SIZE_MULTIPLIER_BIGGER = 1
export const SIZE_MULTIPLIER_SMALLER = 1

export const generateBackground = (
  subcontentWithBackgroundProps?: FullscreenSubcontentWithBackgroundProps,
  from?: string,
  to?: string
) => {
  const hasImageBackground = !!subcontentWithBackgroundProps?.backgroundImage
  const noVisualBackground =
    !subcontentWithBackgroundProps?.backgroundVideoLoopDesktop &&
    !subcontentWithBackgroundProps?.backgroundImage
  const showBackgroundGradient =
    (noVisualBackground &&
      subcontentWithBackgroundProps?.gradientColorFrom &&
      subcontentWithBackgroundProps?.gradientColorTo) ??
    (from && to)
  const showColorBackground =
    noVisualBackground &&
    !showBackgroundGradient &&
    subcontentWithBackgroundProps?.backgroundColor
  const backgroundGradientString = showBackgroundGradient
    ? `linear-gradient(to bottom, ${
        from ?? subcontentWithBackgroundProps?.gradientColorFrom ?? ''
      }, ${to ?? subcontentWithBackgroundProps?.gradientColorTo ?? ''})`
    : ''
  const backgroundColorString = showColorBackground
    ? `linear-gradient(to right, ${
        subcontentWithBackgroundProps?.backgroundColor ?? ''
      }, ${subcontentWithBackgroundProps?.backgroundColor ?? ''})`
    : ''

  return {
    showBackgroundGradient,
    backgroundStyle: {
      backgroundImage: hasImageBackground
        ? `url(${subcontentWithBackgroundProps?.backgroundImage ?? ''})`
        : showBackgroundGradient
        ? backgroundGradientString
        : showColorBackground
        ? backgroundColorString
        : 'unset',
      backgroundBlendMode: hasImageBackground
        ? 'normal'
        : showBackgroundGradient
        ? 'multiply'
        : 'initial',
      backgroundRepeat: hasImageBackground
        ? 'no-repeat'
        : showBackgroundGradient
        ? 'repeat, no-repeat'
        : 'initial',
      backgroundSize: hasImageBackground
        ? 'cover'
        : showBackgroundGradient
        ? 'contain, cover'
        : 'initial',
    },
  }
}
export const ICON_SIZE_DESKTOP = 50
export const ICON_SIZE_TABLET = 40
export const ICON_SIZE_MOBILE = 30

export const MENU_ICON_SIZE_DESKTOP = 60
export const MENU_ICON_SIZE_TABLET = 50
export const MENU_ICON_SIZE_MOBILE = 40
